export const TICKET_TYPE_AGENT = 'agent';
export const TICKET_SIGNUP_SUBJECT = 'Signup - Pending Merchant Docs';
